<template>
  <BaseDropdown ref="dropdownRef" class="hidden md:inline-flex" @on-change="handleDropdownChange">
    <template #trigger>
      <BaseButton is="span" color="accent">
        <ZoomIcon class="h-6 w-6 fill-current mr-2" />
        <span class="hidden sm:inline">
          {{ $t('globals.search') }}
        </span>
      </BaseButton>
    </template>

    <SearchFilter ref="searchRef" @on-enter="dropdownRef?.closeDropdown()" />
  </BaseDropdown>
</template>

<script setup lang="ts">
  import { ref } from 'vue';

  import SearchFilter from '../filters/SearchFilter.vue';
  import ZoomIcon from '../icons/ZoomIcon.vue';
  import BaseButton from '../ui/BaseButton.vue';
  import BaseDropdown from '../ui/BaseDropdown.vue';

  const dropdownRef = ref<InstanceType<typeof BaseDropdown> | null>(null);
  const searchRef = ref<InstanceType<typeof SearchFilter> | null>(null);
  const handleDropdownChange = (open: boolean) => {
    if (open && searchRef.value) {
      searchRef.value.clearInput();
      searchRef.value.focusInput();
    }
  };
</script>
